import {Routes} from '@angular/router';

import {AuthGuard, Const} from '@app/_helper';
import {HomeComponent} from '@app/component/home/home.component';
import {AboutComponent} from '@app/component/about/about.component';

export const routes: Routes = [
  {path: Const.URI_ABOUT, component: AboutComponent},
  {path: Const.URI_HOME, component: HomeComponent, canActivate: [AuthGuard]},
  {path: Const.URI_AUTH, loadChildren: () => import('@app/module/auth/auth.routes').then(m => m.routes)},
  {path: Const.URI_ACCOUNT, loadChildren: () => import('@app/module/account/account.routes').then(m => m.routes)},
  {path: Const.URI_CLIENT, loadChildren: () => import('@app/module/client/client.routes').then(m => m.routes)},
  {path: '**', redirectTo: Const.URI_HOME}
];
